import { KeyFigure, KeyFigureResource } from './KeyFigure';

export const transformToKeyFigure = (resource: KeyFigureResource): KeyFigure => ({
    amount: resource.title,
    label: resource.subtitle,
});
